import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsCA: CultureInfo = {
  name: 'es-CA',
  displayName: 'español (Canadá)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-CA',
  parent: CultureInfoEs
};
